import { useState } from 'react';
import { Mail, X } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { NewsletterForm } from './NewsletterForm';

export const NewsletterModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Newsletter Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-24 right-6 z-40 bg-[var(--primary)] text-black p-4 hover:bg-[#F2D06B] transition-colors group"
        data-testid="newsletter-trigger"
      >
        <Mail size={24} />
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-[var(--surface)] text-white text-sm px-3 py-2 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Suscríbete al Newsletter
        </span>
      </button>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="bg-[var(--surface)] border-white/10 text-white max-w-md">
          <DialogHeader>
            <DialogTitle className="sr-only">Newsletter</DialogTitle>
          </DialogHeader>
          <NewsletterForm onClose={() => setIsOpen(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default NewsletterModal;
